module.exports = __webpack_public_path__ + "media/images/noimage-creator-37b266305dc23adf8c852dc94084204f.png";